import * as React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core';

const Dashboard = () => {
  return (
    <Box p={2}>
      <Typography variant="h4" gutterBottom>
        两废回收后台管理
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="body1">
            欢迎使用两废回收后台管理系统
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Dashboard;